import { translateFunc } from "client/utils/translateFunc";
import { Modal } from "components/common/Modal/Modal";
import { Translate } from "components/common/Translate/Translate";

interface MaxFileSizeConfirmationModalProps {
    isOpen: boolean;
    close: () => void;
    callback: () => void;
}

export const MaxFileSizeConfirmationModal = ({ isOpen, close, callback }: MaxFileSizeConfirmationModalProps) => {
    return (
        <Modal isOpen={isOpen} close={close}>
            <div className="w-full h-screen flex justify-center items-center z-50">
                <div
                    className="inline-flex flex-col gap-4 lg:mx-auto bg-white dark:bg-darkSurface-300 px-8 py-8 rounded-xl mx-4 text-black dark:text-white"
                    onClick={(e) => e.stopPropagation()}
                >
                    <div className="text-xl font-semibold capitalize">
                        <Translate keyName="confirm-settings" />
                    </div>
                    <div>
                        <Translate keyName="max-file-size-disclaimer" />
                    </div>
                    <div className="flex justify-end items-center gap-4 font-semibold">
                        <div
                            className="cursor-pointer px-4 py-2 bg-irGray-400 dark:bg-darkSurface-200 dark:hover:bg-darkSurface-100 hover:bg-irGray-600 rounded-xl capitalize"
                            onClick={close}
                        >
                            {translateFunc("common:cancel")}
                        </div>
                        <div
                            className="cursor-pointer px-4 py-2 bg-irBlue-400 dark:bg-darkPrimary-100 dark:hover:bg-darkPrimary-200 hover:bg-irBlue-600 text-white rounded-xl capitalize"
                            onClick={callback}
                        >
                            {`${translateFunc("common:yes")}, ${translateFunc("common:apply")}`}
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
};
